import React from "react";
import Time from "react-time-format";
import "./Todo.css";
import { isMobile } from "react-device-detect";
class TodoList extends React.Component {
  render() {
    return (
      <table
        className="table table-bordernone trr "
        id="yusif"
        style={{ background: "#f9fafc" }}
      >
        <thead>
          <tr>
            <th
              style={{ color: "gray", fontSize: "12px" }}
              className="fk"
              scope="col"
            >
              {this.props.change_Lang("d_status")}
            </th>
            <th
              style={{ color: "gray", fontSize: "12px" }}
              className="fk"
              scope="col"
            >
              {this.props.change_Lang("todo")}
            </th>
            <th
              style={{ color: "gray", fontSize: "12px" }}
              className="fk"
              scope="col"
            >
              {this.props.change_Lang("date")}
            </th>
          </tr>
        </thead>
        <tbody>
          {this.props.items.map((el, i) => {
            return (
              <tr key={i} className="trr table-hover">
                <td className="digits">
                  {" "}
                  <input
                    type="checkbox"
                    style={{
                      height: "18px",
                      width: "20px",
                      marginTop: "5px",
                      marginRight: "4px",
                    }}
                    className=""
                    checked={el.done === true ? true : null}
                    onChange={() => this.props.onItemCompleted(el._id)}
                  />{" "}
                </td>
                <td className="digits">
                  <p
                    style={{
                      width: isMobile ? "100px" : "700px",
                      fontSize: "14px",
                      textAlign: "justify",
                    }}
                    className="fk"
                  >
                    {el.todo}
                  </p>
                </td>
                <td>
                  {" "}
                  <Time
                    value={el.createdAt}
                    format="YYYY-MM-DD"
                    style={{ color: "black" }}
                    className={`${this.props.lang === "en" ? "" : "fk"}`}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }
}

export default TodoList;
